import {Component, HostBinding, HostListener, Input} from '@angular/core';
import {Blocks} from 'app/entities/blockElements/block.entity';
import {BlockElementAbstractComponent} from 'app/components/blocks/components/blockElementCore';
import {BlockElementButton} from 'app/entities/blockElements/blockElementButton';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-block-element-container',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class BlockElementContainerComponent extends BlockElementAbstractComponent<Blocks> {
  public cardStyles = [];
  ignoreSettings = ['background'];
  constructor(private sanitizer: DomSanitizer) {
    super();
  }

  @HostBinding('class')
  get classes() {
    const classes = super.classes;

    // @todo rework classes assignment

    if (this.rootElement && this.blockElement.type !== 'basic') {
      classes.push('app-container');
    }

    if (this.rootElement) {
      classes.push('root-element');
    }

    if (this.blockElement.type === 'basic') {
      classes.push('basic-element');
    }

    if (this.blockElement.type === 'card') {
      this.cardStyles.push(`background-${this.blockElement.settings?.background}`);

      if (this.blockElement.action) {
        this.cardStyles.push('ion-activatable');
        this.cardStyles.push('block-ripple-parent');
      }
    }

    if (this.blockElement.type === 'empty') {
      classes.push('empty-element');
    }

    if (['empty', 'basic'].includes(this.blockElement.type)) {
      if (this.blockElement.action) {
        classes.push('ion-activatable');
        classes.push('block-ripple-parent');
      }
    }

    if (this.blockElement.icon) {
      classes.push('block-icon-wrapper');

      if (this.blockElement.icon.settings.position === 'before') {
        classes.push('block-icon-wrapper-before');
      }

      if (this.blockElement.icon.settings.position === 'after') {
        classes.push('block-icon-wrapper-after');
      }

      if (this.blockElement.icon.settings.size === 'small') {
        classes.push('block-icon-wrapper-small');
      }

      if (this.blockElement.icon.settings.size === 'medium') {
        classes.push('block-icon-wrapper-medium');
      }

      if (this.blockElement.icon.settings.size === 'big') {
        classes.push('block-icon-wrapper-big');
      }
    }

    return classes;
  }

  @HostListener('click', ['$event'])
  onClick(e) {
    if (this.blockElement.action && ['empty', 'basic'].includes(this.blockElement.type)) {
      this.actionClick();
    }
  }

  safeHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
